var map = {
	"./boissons.png": "1511",
	"./cafeteria.png": "40c6",
	"./casiers.png": "8c3d",
	"./desserts.png": "111d",
	"./entrees.png": "01ad",
	"./formule.png": "651e",
	"./fromages.png": "4a9b",
	"./laitages.png": "3d4a",
	"./plats.png": "b466"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "384d";